import {Component, Fragment} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import {Offcanvas} from "react-bootstrap";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import {notFound} from "../../components/notFound";


class GozareshTasviri extends Component {
    static contextType = simplyContext

    componentDidMount() {
        this.context.fGozareshTasviri(this.props.params.slug1)
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
    }


    render() {
        let images = []
        if (this.context.state.sImageGallery !== null) {
            if (this.context.state.sImageGallery.notFound !== true) {
                images = this.context.state.sImageGallery.gallery.gallery
            }
        }
        return (
            <HelmetProvider>
                <Helmet>
                    <title>{this.props.params.slug1.replace(/-/g, ' ')}</title>
                    <link rel="canonical" href={"https://nasrme.ac.ir/" + this.props.params.slug1} />
                </Helmet>
                {this.context.state.sImageGallery !== null ? (
                    <div className='container-fluid cFlex1'>

                        {header(this.context)}

                        <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                            <div className='cContainer col-12'>
                                <div className='row justify-content-center'>
                                    <div className='col-12 lh-lg'>
                                        <NavLink to={urlDynamic.path.homeFa}
                                                 className='text-white cFontSize13 cHover4 cTransition'>صفحه
                                            اصلی</NavLink>
                                        <span className='mx-1 cFontSize13 text-white'>/</span>
                                        <NavLink to={urlDynamic.path.gozareshTasviriFa}
                                                 className='text-white cFontSize13 cHover4 cTransition'>گزارش
                                            تصویری</NavLink>
                                        <span className='mx-1 cFontSize13 text-white'>/</span>
                                        <h1 className='cColor2 lh-lg mb-0 d-inline-block cFontSize13'>{this.props.params.slug1.replace(/-/g, ' ')}</h1>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.context.state.sImageGallery.notFound === true ? (
                            notFound()
                        ) : (
                            <Fragment>
                                {images.length > 0 ? (
                                    <Fragment>
                                        <div
                                            className='row py-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
                                            <div className='cContainer col-12'>
                                                <div className='row justify-content-center'>
                                                    <div className='col-12 cZindex2'>
                                                        <div className='p-5 cBg10 rounded rounded-3'>
                                                            <ResponsiveMasonry
                                                                columnsCountBreakPoints={{
                                                                    576: 1,
                                                                    768: 3,
                                                                    962: 4,
                                                                    1200: 6
                                                                }}
                                                                gutterBreakpoints={{
                                                                    350: "12px",
                                                                    750: "16px",
                                                                    900: "24px"
                                                                }}
                                                            >
                                                                <Masonry>
                                                                    {images.map((image, i) => (
                                                                        <img
                                                                            key={i}
                                                                            alt={image.originalAlt}
                                                                            src={image.original}
                                                                            onClick={() => this.context.fOffConvas2(i)}
                                                                            className='cCursorPointer'
                                                                            style={{width: "100%", display: "block"}}
                                                                        />
                                                                    ))}
                                                                </Masonry>
                                                            </ResponsiveMasonry>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <Offcanvas backdrop="false" className={`cZindex9991 w-100 bg-dark border-0`}
                                                   show={this.context.state.sOffConvas2}
                                                   onHide={this.context.fOffConvas2}>
                                            <Offcanvas.Header className='text-white py-3 bg-dark'>
                                                گزارش تصویری
                                                <svg onClick={() => this.context.fOffConvas2()}
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="20"
                                                     height="20" fill="currentColor"
                                                     className="bi bi-x-lg cCursorPointer text-white"
                                                     viewBox="0 0 16 16">
                                                    <path
                                                        d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                                                </svg>
                                            </Offcanvas.Header>
                                            <Offcanvas.Body className=''>
                                                <div className='row h-100 align-items-center'>
                                                    <div className='col-12'>
                                                        <ImageGallery showFullscreenButton={false}
                                                                      startIndex={this.context.state.sImageSliderIndex}
                                                                      isRTL={true}
                                                                      showPlayButton={false} lazyLoad={true}
                                                                      showThumbnails={false}
                                                                      items={images}/>
                                                    </div>
                                                </div>
                                            </Offcanvas.Body>
                                        </Offcanvas>
                                    </Fragment>
                                ) : (
                                    <div className='row py-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
                                        <div className='cContainer col-12'>
                                            <div className='row justify-content-center'>
                                                <div className='col-12 cZindex2'>
                                                    <div className='p-4 p-md-5'>
                                                        <p className='text-center mb-0 cFontSize14_768 cFontSize16 cColor2 fw-bold lh-lg'></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Fragment>
                        )}


                        {footer()}

                    </div>
                ) : null}

            </HelmetProvider>
        )
    }
}

export default withRouter(GozareshTasviri)